import { PublicClientApplication } from '@azure/msal-browser';

// Public client (PKCE, no secret) for the single-tenant Entra ID app registration.
// clientId/tenantId come from the backend's /api/v1/publicConfig at runtime rather
// than a build-time REACT_APP_* env var, so rotating them doesn't require a rebuild.
export default function createMsalInstance({ msClientId, msTenantId }) {
  return new PublicClientApplication({
    auth: {
      clientId: msClientId,
      authority: `https://login.microsoftonline.com/${msTenantId}`,
      redirectUri: window.location.origin,
    },
  });
}
